import styled, { css, keyframes } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
const SIZES = {
    sm: { height: 11, gap: 1, bars: [4, 9, 6] },
    md: { height: 14, gap: 2, bars: [6, 12, 8] },
    lg: { height: 18, gap: 2, bars: [8, 16, 11] },
};
const barOneAnimation = keyframes `
  0% { transform: scaleY(0.4); opacity: 0.5; }
  18% { transform: scaleY(0.85); opacity: 1; }
  33% { transform: scaleY(0.55); opacity: 0.65; }
  52% { transform: scaleY(0.95); opacity: 1; }
  67% { transform: scaleY(0.45); opacity: 0.55; }
  84% { transform: scaleY(0.78); opacity: 0.9; }
  100% { transform: scaleY(0.4); opacity: 0.5; }
`;
const barTwoAnimation = keyframes `
  0% { transform: scaleY(0.6); opacity: 0.7; }
  14% { transform: scaleY(0.35); opacity: 0.45; }
  31% { transform: scaleY(0.9); opacity: 1; }
  49% { transform: scaleY(0.45); opacity: 0.55; }
  63% { transform: scaleY(1); opacity: 1; }
  79% { transform: scaleY(0.55); opacity: 0.65; }
  100% { transform: scaleY(0.6); opacity: 0.7; }
`;
const barThreeAnimation = keyframes `
  0% { transform: scaleY(0.72); opacity: 0.8; }
  22% { transform: scaleY(0.95); opacity: 1; }
  40% { transform: scaleY(0.38); opacity: 0.5; }
  58% { transform: scaleY(0.85); opacity: 0.95; }
  74% { transform: scaleY(0.48); opacity: 0.6; }
  89% { transform: scaleY(0.92); opacity: 1; }
  100% { transform: scaleY(0.72); opacity: 0.8; }
`;
export const Bar = styled.span `
  width: ${pxToRem(2)};
  border-radius: ${theme.borderRadius.xs};
  background-color: currentcolor;
  transform-origin: center;
  animation-timing-function: cubic-bezier(0.45, 0.05, 0.55, 0.95);
  animation-iteration-count: infinite;

  &:nth-child(1) {
    animation-name: ${barOneAnimation};
    animation-duration: 2.4s;
  }

  &:nth-child(2) {
    background-color: var(--loading-bars-accent, currentColor);
    animation-name: ${barTwoAnimation};
    animation-duration: 2.9s;
  }

  &:nth-child(3) {
    animation-name: ${barThreeAnimation};
    animation-duration: 2.6s;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
/**
 * The bars paint in `currentColor`, so a parent recolours them with `color`.
 * Set `--loading-bars-accent` to pick out the middle bar.
 */
export const Container = styled.span `
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: ${({ $size }) => pxToRem(SIZES[$size].height)};
  gap: ${({ $size }) => pxToRem(SIZES[$size].gap)};
  color: ${theme.swatches.warm[500]};

  ${({ $size }) => SIZES[$size].bars.map((height, index) => css `
        ${Bar}:nth-child(${index + 1}) {
          height: ${pxToRem(height)};
        }
      `)}
`;
